<template>
  <div class="UserManagement">
    <el-form :inline="true"
             :model="searchForm"
             @keyup.enter.native="getDataList('search')">
      <el-form-item label="房间号">
        <el-select v-model="searchForm.apartmentAssetCode"
                   @change="getDataList('search')">
          <el-option v-for="item in homeList"
                     :key="item.apartmentAssetCode"
                     :label="item.apartmentAssetName"
                     :value="item.apartmentAssetCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="人员名称">
        <el-input v-model="searchForm.apartmentUserName"
                  placeholder="人员名称"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="searchForm.phone"
                  placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="人员类型">
        <el-select v-model="searchForm.apartmentUserType">
          <el-option v-for="item in userTypeList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search"
                   size="small"
                   type="primary"
                   @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete"
                   size="small"
                   plain
                   type="primary"
                   @click="reset()">清空
        </el-button>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-button icon="el-icon-plus"
                     size="small"
                     type="primary"
                     @click="openModifyDialog()">添加人员
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             style="margin-top: 20px;">

      <el-tab-pane :label="item.apartmentName"
                   :name="item.apartmentCode"
                   v-for="(item, index) in apartmentlist"
                   :key="index">

        <el-table class="dataTable"
                  v-loading="dataListLoading"
                  :data="dataList"
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  border>
          <el-table-column label="人员名称"
                           prop="apartmentUserName">
          </el-table-column>
          <el-table-column label="手机号"
                           prop="phone">
          </el-table-column>
          <el-table-column label="所属房间"
                           prop="apartmentAssetName">
          </el-table-column>
          <el-table-column label="人员类型"
                           prop="apartmentUserType">
            <template slot-scope="scope">
              <span>{{ scope.row.apartmentUserType == 3 ? '租户(户主)' : '用户(成员)' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           prop="createdTime">
          </el-table-column>
          <el-table-column label="操作"
                           width="400">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="primary"
                         @click="openDetailDialog(scope.row)">查看</el-button>
              <el-button size="mini"
                         type="primary"
                         @click="openModifyDialog(scope.row)">编辑</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="pageIndex"
                       :page-size="pageSize"
                       :page-sizes="[10, 20, 50, 100]"
                       :total="totalPage"
                       background
                       layout="total, sizes, prev, pager, next, jumper"
                       @size-change="sizeChangeHandle"
                       @current-change="currentChangeHandle">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增&修改人员信息 -->
    <el-dialog :title="modifyForm.apartmentUserCode ? '修改人员信息' : '添加人员'"
               :visible.sync="modifyDialog"
               width="40%"
               :before-close="cancelModifyDialog">
      <el-form class="modifyForm"
               ref="modifyForm"
               :model="modifyForm"
               :rules="modifyRule"
               label-width="40%">
        <el-form-item label="人员类型"
                      prop="apartmentAssetType">
          <el-radio-group v-model="modifyForm.apartmentUserType"
                          size="small">
            <el-radio v-for="item in userTypeList"
                      :key="item.value"
                      :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="人员名称"
                      prop="apartmentUserName">
          <el-input style="width: 200px;"
                    v-model="modifyForm.apartmentUserName"
                    placeholder="请输入人员名称"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="phone">
          <el-input style="width: 200px;"
                    v-model="modifyForm.phone"
                    placeholder="手机号"
					:disabled="modifyForm.apartmentUserCode"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>
        <el-form-item label="所属房间">
          <el-select v-model="modifyForm.apartmentAssetCode">
            <el-option v-for="item in homeList"
                       :key="item.apartmentAssetCode"
                       :label="item.apartmentAssetName"
                       :value="item.apartmentAssetCode" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelModifyDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="modifyHandle()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 人员信息详情 -->
    <el-dialog title="人员信息详情"
               :visible.sync="detailDialog"
               width="40%"
               :before-close="cancelDetailDialog">
      <el-form class="detailForm"
               ref="detailForm"
               :model="detailForm"
               label-width="40%">
        <el-form-item label="人员名称："
                      prop="apartmentUserName">
          <span>{{ detailForm.apartmentUserName}}</span>
        </el-form-item>
        <el-form-item label="手机号："
                      prop="phone">
          <span>{{ detailForm.phone}}</span>
        </el-form-item>
        <el-form-item label="人员类型："
                      prop="apartmentUserType">
          <span>{{ detailForm.apartmentUserType == 3 ? '租户' :  detailForm.apartmentUserType == 4 ? '用户' : '' }}</span>
        </el-form-item>
        <el-form-item label="所属房间："
                      prop="apartmentAssetName">
          <span>{{ detailForm.apartmentAssetName}}</span>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/UserManagement.css'
export default {
  data() {
    return {
      apartmentCode: '',
      apartmentlist: [],
      homeList: [],
      activeName: '',
      userTypeList: [
        {
          value: 3,
          label: '租户(户主)',
        },
        {
          value: 4,
          label: '用户(成员)',
        },
      ],
      searchForm: {},
      dataListLoading: false,
      dataList: [],
      pageIndex: 0,
      pageSize: 10,
      totalPage: 0,
      modifyDialog: false,
      modifyForm: {},
      modifyRule: {
        apartmentUserType: [
          { required: true, message: '人员类型不能为空', trigger: 'blur' },
        ],
        apartmentUserName: [
          { required: false, message: '人员名称不能为空', trigger: 'blur' },
        ],
        phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
      },
      detailDialog: false,
      detailForm: {},
      apartmentAssetCodeOld: '',
      apartmentAssetNameOld: '',
    }
  },

  computed: {},

  created() {
    let self = this

    self.getApartmentlist()
  },

  mounted() {},

  methods: {
    handleClick(tab, event) {
      let self = this

      self.apartmentCode = tab.name

      let str = {
        apartmentCode: self.apartmentCode,
        flag: 1,
      }
      self.getHomeList(str)
    },
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取公寓列表
    getApartmentlist() {
      let self = this

      self.$axios
        ._getApartmentlist()
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.apartmentlist = datas.data

            self.activeName = self.apartmentlist[0].apartmentCode
            self.apartmentCode = self.apartmentlist[0].apartmentCode

            let str = {
              apartmentCode: self.apartmentlist[0].apartmentCode,
              flag: 1,
            }
            self.getHomeList(str)
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取房间列表
    getHomeList(fristApartment) {
      let self = this

      let str = fristApartment

      self.$axios
        ._getHomelist(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.homeList = datas.data.content
            self.searchForm.apartmentAssetCode =
              self.homeList[0].apartmentAssetCode

            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取人员列表
    getDataList(type) {
      let self = this

      if (!self.searchForm.apartmentAssetCode) {
        self.$message.error('请选择房间号')
        return
      }

      self.dataListLoading = true

      if (type == 'search') {
        self.pageIndex = 0
      }

      let str = {
        apartmentCode: self.apartmentCode,
        flag: 4,
        pageNow: self.pageIndex,
        pageSize: self.pageSize,
        param: self.searchForm.apartmentAssetCode,
      }

      self.$axios
        ._getUserlist(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.dataList = datas.data.content
            self.totalPage = datas.data.totalElements
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 0
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 新增&修改弹窗
    openModifyDialog: function (row) {
      let self = this

      let modifyData = {}

      if (row) {
        modifyData = row
        self.apartmentAssetCodeOld = row.apartmentAssetCode

        let obj = {}

        self.homeList.map((item) => {
          item.apartmentAssetCode == self.apartmentAssetCodeOld && (obj = item)
        })

        self.apartmentAssetNameOld = obj.apartmentAssetName

        self.modifyForm = modifyData
      }

      console.log(self.modifyForm, 'self.modifyForm')
      self.modifyDialog = true
    },

    // 新增&修改
    modifyHandle: function () {
      let self = this

      if (!self.modifyForm.apartmentUserType) {
        self.$message.error('请选择人员类型')
        return
      }

      let apartmentCode = self.apartmentCode
      let apartmentUserType = self.modifyForm.apartmentUserType
      let apartmentUserName = self.modifyForm.apartmentUserName
      let phone = self.modifyForm.phone
      let apartmentUserCode = self.modifyForm.apartmentUserCode
      let apartmentAssetCode = self.modifyForm.apartmentAssetCode

      let obj = {}

      self.homeList.map((item) => {
        item.apartmentAssetCode == apartmentAssetCode && (obj = item)
      })

      let apartmentAssetName = obj.apartmentAssetName

      if (apartmentUserCode) {
        let str = {
          apartmentCode: apartmentCode,
          apartmentAssetCode: self.apartmentAssetCodeOld,
          apartmentAssetName: self.apartmentAssetNameOld,
          apartmentUserCode: apartmentUserCode,
          apartmentUserType: apartmentUserType,
          apartmentUserName: apartmentUserName,
          phone: phone,
        }

        self.$axios
          ._putUserInfo(str)
          .then((res) => {
            const datas = res.data
            if (datas.code == 0) {
              let newRoom = new FormData()

              newRoom.append('apartmentCode', apartmentCode)
              newRoom.append('apartmentAssetCode', self.apartmentAssetCodeOld)
              newRoom.append('apartmentAssetCodeNew', apartmentAssetCode)
              newRoom.append('apartmentUserCode', apartmentUserCode)
              self.changeRoom(newRoom)
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      } else {
        let formdata = new FormData()

        formdata.append('apartmentCode', apartmentCode)
        formdata.append('apartmentAssetName', apartmentAssetName)
        formdata.append('apartmentUserType', apartmentUserType)
        formdata.append('apartmentUserName', apartmentUserName)
        formdata.append('phone', phone)

        self.$axios
          ._addUserInfo(formdata)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('添加成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }
    },

    // 更换房间
    changeRoom: function (str) {
      let self = this

      self.$axios
        ._putUserChangeRoom(str)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            self.cancelModifyDialog()
            self.getDataList('search')
            self.$message.success('修改成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常，请联系管理员')
        })
    },

    // 关闭 新增&修改弹窗
    cancelModifyDialog: function () {
      let self = this

      // Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
      // self.$refs.modifyForm.resetFields()
      self.modifyForm = {}
      self.modifyDialog = false
    },

    // 打开 人员信息弹窗
    openDetailDialog: function (row) {
      let self = this

      let detailData = {}

      if (row) {
        detailData = row

        self.detailForm = detailData
      }

      self.detailDialog = true
    },

    // 关闭 人员信息弹窗
    cancelDetailDialog: function () {
      let self = this

      // Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))
      self.modifyForm = {}
      self.detailDialog = false
    },

    // 删除人员
    handleDelete(row) {
      let self = this

      let apartmentCode = row.apartmentCode
      let apartmentAssetCode = row.apartmentAssetCode
      let apartmentUserCode = row.apartmentUserCode

      let str = `?apartmentCode=${apartmentCode}&apartmentAssetCode=${apartmentAssetCode}&apartmentUserCode=${apartmentUserCode}`
      self
        .$confirm(`是否确认要删除人员 "${row.apartmentUserName}"`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delUser(str)
        })
        .then((data) => {})
    },

    delUser(str) {
      let self = this

      self.$axios
        ._deleteUser(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/UserManagement.vue